import { images as coreImages } from '@adc/ui-core'
import defaultPropertyImage from '../no_image_available.png'
import favicon from '../favicon.png'
import smartsaleFavicon from '../smartsale-favicon.png'
import auctioncomIconLogo from '../auction-logo.svg'
import smartsaleIconLogo from '../smartsale-logo.svg'
import auctioncomLogo from '../logo-light.svg'
import smartsaleLogo from '../smartsale-powered-logo.png'

const images = {
  ...coreImages,
  defaultPropertyImage,
  favicon,
  smartsaleFavicon,
  auctioncomIconLogo,
  smartsaleIconLogo,
  auctioncomLogo,
  smartsaleLogo,
}

export { images }
